export const userApi = {
  list: {
      method: 'post',
      api: 'backend/user/list'
  },
  save: {
      method: 'post',
      api: 'backend/user/save'
  },
  del: {
      method: 'post',
      api: 'backend/user/del'
  },
}